import { createRouter } from '@tanstack/react-router';

import { routeTree } from '../routes.gen';
import { queryClient } from './queryClient';

export const router = createRouter({
	routeTree,
	defaultPreload: 'viewport',
	defaultStructuralSharing: true,
	scrollRestoration: true,
	context: {
		getTitle: undefined,
		queryClient,
		// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
		auth: undefined!
	}
});

export type PraetoidRouter = typeof router;

declare module '@tanstack/react-router' {
	interface Register {
		router: typeof router;
	}
}
